import { useState, useRef } from 'react';

export default function KpiTooltip({ text, children, delay = 250 }) {
  const [show, setShow] = useState(false);
  const timer = useRef(null);
  if (!text) return children;
  const enter = () => { timer.current = setTimeout(() => setShow(true), delay); };
  const leave = () => { clearTimeout(timer.current); setShow(false); };
  return (
    <div className="relative" onMouseEnter={enter} onMouseLeave={leave} onFocus={enter} onBlur={leave}>
      {children}
      {show && (
        <div role="tooltip"
          className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 rounded-lg border text-xs whitespace-normal max-w-[260px] z-50 pointer-events-none shadow-sm"
          style={{
            background: 'var(--bg-card, #fff)',
            borderColor: 'var(--border-card, #E5E7EB)',
            color: 'var(--text-primary, #1A1A2E)',
            lineHeight: 1.4,
          }}>
          {text}
          <span className="absolute left-1/2 -translate-x-1/2 w-0 h-0"
            style={{ top: '100%', borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '5px solid var(--border-card, #E5E7EB)' }} />
          <span className="absolute left-1/2 -translate-x-1/2 w-0 h-0"
            style={{ top: '100%', marginTop: '-1px', borderLeft: '4px solid transparent', borderRight: '4px solid transparent', borderTop: '4px solid var(--bg-card, #fff)' }} />
        </div>
      )}
    </div>
  );
}
